/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FileTreeWithKeyFileWithKeyParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('file')],
    ['name', codecString],
    ['key', codecString],
    ['hash', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class FileTreeWithKeyFileWithKey extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FileTreeWithKeyFileWithKeyParser.decode(input).map(res => new FileTreeWithKeyFileWithKey(res));
    }
    static unsafeDecode(input) {
        return FileTreeWithKeyFileWithKey.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FileTreeWithKeyFileWithKeyParser.encode(data);
    }
    static schema() {
        return FileTreeWithKeyFileWithKeyParser.schema();
    }
}
